<template lang="pug">
  v-autocomplete(
    outlined
    multiple
    chips
    deletable-chips
    hide-details
    :items="availableFacilities"
    item-text="facility_name"
    item-value="id"
    v-model="facilityIdsModel"
    placeholder="Select facilities"
    aria-label="Select facilities"
    clearable
    :success="facilityIdsModel.length == 0"
    :loading="loading"
  )
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'availableFacilities'
    ]),
    ...mapState({
      loading: state => state.main.loading
    }),
    facilityIdsModel: {
      get() {
        return this.$store.state.main.facilityIds
      },
      set(value) {
        this.$store.commit('setFacilityIds', value)
        this.$store.dispatch('lazyRefresh')
      }
    }
  }
}
</script>